import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Is JavaScript really getting too complex?",
  "description": "",
  "published": "2019-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/is-javascript-really-getting-too-complex/swizec/9117"],
  "categories": "Front End, Technical",
  "hero": "./img/vxNSHwE.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You sometimes hear people on the internet complain that JavaScript is becoming too complex. They reminisce of the old days when you could write some code, plop it in a `}<inlineCode parentName="p">{`<script>`}</inlineCode>{` tag, and it worked.`}</p>
    <p>{`Now you need Babel, and Webpack bundling, and transpiling, and a bazillion different versions of JavaScript, and a framework for components, a framework for CSS, and and it's all just one big hairy mess.`}</p>
    <p>{`Baloney`}</p>
    <p><img parentName="p" {...{
        "src": "/7d5bc8f08d09559fd435ada67622a4cf/media-3orif5GoP132DEKTF6-giphy.gif",
        "alt": "baloney giphy"
      }}></img></p>
    <p>{`JavaScript is wonderful. ❤️`}</p>
    <p>{`The JavaScript community is one of the most welcoming beginner friendly communities I've ever met. Everyone is welcome. Everyone is productive. Everyone can get started.`}</p>
    <p>{`With experience or without, there is a place for you in the JavaScript world.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Remember that one time I tried to use Kotlin and fell flat on my face?`}<br parentName="p"></br><br parentName="p"></br>{`Y'all who only ever used JavaScript don't know how good you have it. `}<br parentName="p"></br><br parentName="p"></br>{`JavaScript is a slice of heaven in the programming world. TypeScript too. No other community spends so much time making life easier. `}<a parentName="p" {...{
          "href": "https://t.co/HHYpktVUcs"
        }}>{`https://t.co/HHYpktVUcs`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1137419997527961601"
      }}>{`June 8, 2019`}</a></blockquote>
    <p>{`What I love about the JavaScript community is how hard everyone works to make it `}<em parentName="p">{`even more accessible`}</em>{`. There's a wealth of resources to learn from, a bunch of tools making your life easier, abstracting away the complexities. 👌`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`In my experience other communities (except maybe Ruby/Rails) do focus on making life easier, but their target audience is the engineer with 10 years of experience.`}<br parentName="p"></br><br parentName="p"></br>{`JavaScript instead is like "How do we make this more accessible to someone with 10 days experience?"`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1137420747813474305"
      }}>{`June 8, 2019`}</a></blockquote>
    <p>{`In the JavaScript world you can find everything from total beginner stuff like `}<em parentName="p">{`"How to write a for loop and why"`}</em>{` to complex topics you run into after years of working on real projects.`}</p>
    <p>{`There's even people streaming their work! I would've killed to learn by watching experts work when I was a kid.`}</p>
    <p>{`You know how I learned to code?`}</p>
    <p>{`By opening `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Turbo_Pascal"
      }}>{`Turbo Pascal`}</a>{`'s help files, in a language I barely understood (English), and `}<em parentName="p">{`trying things`}</em>{`. It was fun but dear god it was slow.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/5f980465798d7d2cb69fb3f1a8094e60/891d5/vxNSHwE.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.33183856502242%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'250\\'%20viewBox=\\'0%200%20400%20250\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M151%207v3H0v230h45c44%200%2045%200%2045-2s-1-2-12-2l-13-1%2013-1c11%200%2012%200%2012-2s1-2%205-2%205%200%205%202l-2%201-2%202%202%202%202%202%20143%201a1591%201591%200%2000144-3l2-2-2-1c-3-1-3-4%201-4%202%200%202%200%202%205v5h11V10h-24l-25-1%201-1%201-1h-1l-1-1c0-1%200-2%201-1l1-1-1-1c-2%200-2%201-2%204v3h-47a430%20430%200%2001-46-2l1-1h-1l-1-1c0-1%200-2%201-1l1-1-1-1c-2%200-2%201-2%204v3h-26c-26%200-26%200-26-2l-1-2-1-1c-1-1-1-1-1%201l1%202v1a314%20314%200%2001-49-1l1-1h-1l-1-1c0-1%200-2%201-1l1-1-1-1c-2%200-2%201-2%204M2%2015v111l1%20110h18l19-1-18-1H3V16h4l3-1H2m23%200l70%201a942%20942%200%20000-2l-70%201m210%200l65%201a814%20814%200%20000-2l-65%201M105%20125v65h185V60H105v65m110%2043v2h-35v5h40v-5c0-5%200-5-2-5s-3%201-3%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5f980465798d7d2cb69fb3f1a8094e60/ca0a1/vxNSHwE.webp 223w", "/static/5f980465798d7d2cb69fb3f1a8094e60/75680/vxNSHwE.webp 445w", "/static/5f980465798d7d2cb69fb3f1a8094e60/8d1ba/vxNSHwE.webp 890w", "/static/5f980465798d7d2cb69fb3f1a8094e60/3838e/vxNSHwE.webp 1335w", "/static/5f980465798d7d2cb69fb3f1a8094e60/7afe4/vxNSHwE.webp 1520w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/5f980465798d7d2cb69fb3f1a8094e60/e92b6/vxNSHwE.png 223w", "/static/5f980465798d7d2cb69fb3f1a8094e60/e66bf/vxNSHwE.png 445w", "/static/5f980465798d7d2cb69fb3f1a8094e60/4ef49/vxNSHwE.png 890w", "/static/5f980465798d7d2cb69fb3f1a8094e60/4e814/vxNSHwE.png 1335w", "/static/5f980465798d7d2cb69fb3f1a8094e60/891d5/vxNSHwE.png 1520w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/5f980465798d7d2cb69fb3f1a8094e60/4ef49/vxNSHwE.png",
              "alt": "vxNSHwE",
              "title": "vxNSHwE",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And I didn't even have the internet. Once a week I could ask my teacher about things and that was it. No Google, no blogs, not even books.`}</p>
    <p>{`I probably could've had books but have you tried to read a college text book as a 12 year old? It doesn't work very well.`}</p>
    <p><img parentName="p" {...{
        "src": "/de6878b337c6eba4eb504d2cfbe70f7b/media-13uInxupYYtNf2-giphy.gif",
        "alt": "men_in_black_textbooks giphy"
      }}></img></p>
    <p>{`That's what learning how to code used to look like. You can poke around and try stuff, ask one or two mentors, or read books way beyond your level.`}</p>
    <p>{`Now you have blogs and courses and video streamers and experts answering questions and ... it's amazing. I love it 😍`}</p>
    <h2 {...{
      "id": "beginner-friendly-helps-everyone"
    }}>{`Beginner friendly helps everyone`}</h2>
    <p>{`The best part is that this helps everyone. Even experts.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`And when you make something accessible to people with 10 days experience.`}<br parentName="p"></br><br parentName="p"></br>{`You're making my life easier too so I can focus on solving problems instead of programming tricks. And I love that ❤️`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1137420748941717504"
      }}>{`June 8, 2019`}</a></blockquote>
    <p>{`When you make something more accessible to beginners, when it's quicker to get started, that helps experienced people too.`}</p>
    <p>{`Consider this 👇`}</p>
    <p>{`Would you rather spend an hour setting up Webpack and Babel and your basic file structure and a development server and hot reloading and all the plugins or ...`}</p>
    <p>{`... run `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` and get started building your app in 30 seconds?`}</p>
    <p>{`I know what I'd pick 😉`}</p>
    <p>{`That same CRA tool that makes it easier for beginners to start with React, makes it quicker for an expert, too.`}</p>
    <p>{`Or how about this 👇`}</p>
    <p>{`Would you rather spend your time thinking about memory optimization, clearing array buffers, making sure there's no overflows, thinking about deallocation, and memory paging, and swapping and thrashing and all those things ...`}</p>
    <p>{`... or trust a garbage collector is Good Enough and focus on solving your business problems?`}</p>
    <p>{`yeah, exactly`}</p>
    <h2 {...{
      "id": "we-stand-on-the-shoulders-of-giants"
    }}>{`We stand on the shoulders of giants`}</h2>
    <p>{`Computer science and software engineering go back many decades. Every generation solved a new set of challenges and we take those solutions for granted.`}</p>
    <p>{`We love to think the stuff we learned in our engineering youth represents The Fundamental Fundamentals. We scoff at the new kids on the block. `}<em parentName="p">{`Pha, they don't even know how to efficiently write to a drum-memory. Useless`}</em></p>
    <p>{`Wait what, a drum memory?`}</p>
    <p>{`Read `}<a parentName="p" {...{
        "href": "http://www.catb.org/~esr/jargon/html/story-of-mel.html"
      }}>{`The story of Mel`}</a>{` my friend, it is amazing.`}</p>
    <p>{`But here's the thing, you don't know (me neither) about drum memory because `}<em parentName="p">{`we don't need to`}</em>{`.`}</p>
    <p>{`Someone before us solved that problem.`}</p>
    <p>{`We also don't think about optimizing registry assignment, aligning memory so it's used efficiently, writing to hard drives without leaving huge holes, or cleaning up our own memory. Tools baked right into our environment handle that for us.`}</p>
    <p>{`And that's amazing.`}</p>
    <p>{`Time saved thinking about low level concerns, is time you get to use for problems unique to you and your company.`}</p>
    <p>{`So please, keep adding complexity, keep adding abstractions, the more you come up with, the less time I have to waste on silly little details :)`}</p>
    <p><img parentName="p" {...{
        "src": "/838e18a5cde0e53c9cf041e01dc63d78/media-BnJchna9dxUD6-giphy.gif",
        "alt": "killin_it giphy"
      }}></img></p>
    <p>{`Enjoy your Monday, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      